import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Loading } from "@carbon/react";

const ProtectedRoute = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div>
        <Loading description="Loading indicator" />
      </div>
    )
  });

  return <Component />;
};

export default ProtectedRoute;
